import { render, staticRenderFns } from "./SkupDetails.vue?vue&type=template&id=2e733de8&scoped=true&"
import script from "./SkupDetails.vue?vue&type=script&lang=js&"
export * from "./SkupDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e733de8",
  null
  
)

export default component.exports